/**
 * LocationPill - small reusable label for an extracted conversation location.
 * Renders nothing when no city is available so callers don't need to guard.
 */

import { MapPin } from 'lucide-react';

const tooltipFor = (loc) =>
  [loc.city, loc.state, loc.country].filter(Boolean).join(', ');

const LocationPill = ({ location, variant = 'card' }) => {
  if (!location || !location.city) return null;
  const tip = tooltipFor(location);

  if (variant === 'detail') {
    return (
      <span className="inline-flex items-center space-x-1.5 text-sm text-gray-700">
        <MapPin size={14} className="text-gray-500" />
        <span>{tip}</span>
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center space-x-1 text-xs px-1.5 py-0.5 rounded bg-slate-100 text-slate-600"
      title={tip}
    >
      <MapPin size={10} className="text-slate-500" />
      <span>{location.city}</span>
    </span>
  );
};

export default LocationPill;
